//
// This comment serves as a convenient way to force R2 to build all apps, both for your pull request preview, and in
// production after your pull request is merged.
//
//

export default 52;
